import {
  FETCH_TIME2CHAT_NUMBERS,
} from '../actions/types/time2chatNumberTypes';
import {
  FAILED,
  STARTED,
  SUCCEEDED,
  getFailed,
  getStarted,
  getSucceeded,
} from '../../utils/helpers/store-helpers';

const initialState = {
  items: [],
  fetchStatus: '',
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getStarted(FETCH_TIME2CHAT_NUMBERS):
      return { ...state, fetchStatus: STARTED };
    case getFailed(FETCH_TIME2CHAT_NUMBERS):
      return { ...state, fetchStatus: FAILED };
    case getSucceeded(FETCH_TIME2CHAT_NUMBERS):
      return { ...state, items: payload ?? [], fetchStatus: SUCCEEDED };
    default:
      return state;
  }
};

export default reducer;
